exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".book-editor-wrap[data-v-de5e984c]{height:55vh}", ""]);

// exports
